var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, CircularProgress, Button } from '@mui/material';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import PaymentDetails from "./payment-details";
import { useTranslation } from "react-i18next";
var PaymentDetailsDialog = function (_a) {
    var paymentResponse = _a.paymentResponse, opened = _a.opened, isPaymentInProgress = _a.isPaymentInProgress, handleClosePaymentDetails = _a.handleClosePaymentDetails, dialogTitle = _a.dialogTitle, returnUrl = _a.returnUrl, isVirtualTerminal = _a.isVirtualTerminal;
    var handleBackToShopRedirect = function () {
        var redirectUrl = new URL(returnUrl ? returnUrl : "https://pay.dev.areto-payment.com/Dev/ThankYou");
        if (paymentResponse.detail) {
            redirectUrl.searchParams.append('internalOrderId', paymentResponse.detail.internalOrderId);
            redirectUrl.searchParams.append('state', paymentResponse.detail.state);
            redirectUrl.searchParams.append('orderId', paymentResponse.detail.orderId);
            if (paymentResponse.detail.token) {
                redirectUrl.searchParams.append('token', paymentResponse.detail.token);
            }
        }
        window.location.href = redirectUrl.href;
    };
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    return (_jsxs(Dialog, __assign({ open: opened, onClose: handleClosePaymentDetails, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", fullWidth: true }, { children: [_jsx(DialogTitle, __assign({ id: "alert-dialog-title", sx: { bgcolor: '#00BCD4', color: 'white' } }, { children: dialogTitle })), _jsxs(DialogContent, { children: [isPaymentInProgress &&
                        _jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center', mt: 1 } }, { children: _jsx(CircularProgress, {}) })), !isPaymentInProgress &&
                        _jsx(PaymentDetails, { paymentResponse: paymentResponse })] }), _jsx(DialogActions, { children: !isPaymentInProgress &&
                    _jsx(_Fragment, { children: isVirtualTerminal
                            ? _jsx(Button, __assign({ onClick: function (event) { return handleClosePaymentDetails(event, ''); } }, { children: t('Close') }))
                            : _jsx(Button, __assign({ onClick: handleBackToShopRedirect }, { children: t('Back to shop') })) }) })] })));
};
export default PaymentDetailsDialog;
